import { shallowEqual, useSelector } from 'react-redux'

import { ActionIconWrapper } from '@components/Inbox/TitleBar/TitleBar.styled'
import ActionIcon from '@components/UI/ActionIcon'
import { ConnectedTrackedRoute } from '@components/UI/TrackedRoute'
import { useIntl } from '@context/Internationalization/useIntl'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store/index'
import { selectAllowSubmissionsMultiSelect } from '@store/submissions'
import Theme from '@theme'

export const InboxTitleBarToggleSelectionOptionAction: React.FC<{
  toggleSelectionMode: VoidFunction
  campaignId: number
}> = ({ toggleSelectionMode, campaignId }) => {
  const { intl } = useIntl()
  const { allowSelection } = useSelector((state: IApplicationState) => ({
    allowSelection: selectAllowSubmissionsMultiSelect(state, campaignId),
  }), shallowEqual)

  if (!allowSelection) {
    return null
  }

  return (
    <ConnectedTrackedRoute eventName={EventTrackingNames.BulkSelectStart} campaignId={campaignId}>
      <ActionIconWrapper>
        <ActionIcon
          glyph="select"
          highlighted={false}
          showNotification={false}
          color={Theme.grey900Color}
          tooltip={intl.formatMessage({ id: 'inbox.titlebar.action.select' })}
          size={1.5}
          onClick={toggleSelectionMode}
          elementName="select"
        />
      </ActionIconWrapper>
    </ConnectedTrackedRoute>
  )
}
